import ApiClient from './ApiClient';

class UnofficialCampaignsAPI extends ApiClient {
  constructor() {
    super('unofficial_campaigns', { accountScoped: true });
  }
}

export default new UnofficialCampaignsAPI();
